import { render, staticRenderFns } from "./MaterialComboChartCard.vue?vue&type=template&id=5947673a&"
import script from "./MaterialComboChartCard.vue?vue&type=script&lang=js&"
export * from "./MaterialComboChartCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialComboChartCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports